import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { BtnToolbar, BtnGroup, Btn, Dropdown, Modal, Tabs, Tab, tooltip, Popover, Collapse, Pagination, Typeahead, ProgressBar } from 'uiv';

import vSelect from 'vue-select';
import './pluginsConfig/vue-select-config';
import '@/core/styles/vue-select-overrides.scss';

import VueUploadComponent from 'vue-upload-component';

// Form Validation library - Start
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import '@/core/vee-validation-rules';
// Form Validation library - End

import '@/core/styles/ag-grid-overrides.scss';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { ModuleRegistry } from '@ag-grid-community/core';

import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { CsvExportModule} from '@ag-grid-community/csv-export';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import PrimaryButton from '@/core/components/PrimaryButton';
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import PortalWidget from '@/core/components/PortalWidget.vue';
import ColumnToggle from '@/core/components/ColumnToggle/ColumnToggle.vue';
import Loader from '@/core/components/Loader';

// Charting - Start
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import Drilldown from 'highcharts/modules/drilldown';
import ColumnSelectionShowRangePlugin from '@/core/plugins/Highcharts/ColumnSelectionShowRangePlugin';
import ZeroAlignPlugin from '@/core/plugins/Highcharts/ZeroAlignPlugin';
import PieTitlePlugin from '@/core/plugins/Highcharts/PieTitlePlugin';
// Charting - End

import VueTour from 'vue-tour';
// import 'vue-tour/dist/vue-tour.css';
import '@/core/styles/vue-tour-overrides.scss';

import '@/angularBridgeCode/defaultI18n';
import '@/angularBridgeCode/ngVueDirectives';
import '@/angularBridgeCode/services/versionCheck';
import ringbaPortalComponents from '@/angularBridgeCode/ringbaPortal.componentsModule';
import { camelCaseFormat } from '@/core/filters/camelCaseFormat';
import { utcToLocalFormat } from '@/core/filters/utcToLocalFormat';

import GenericProps from '@/modules/ivrs/components/CallFlowsEditor/NodeProperties/GenericProps.vue';

import VueSlider from 'vue-slider-component';
import '@/core/styles/vue-slider-component-overrides.scss';

import copyToClipboard from '@/core/directives/CopyToClipboard';
import PrefixInput from '@/core/directives/PrefixInput';
import NumbersOnly from '@/core/directives/NumbersOnly';
import PopoverClickOutside from '@/core/directives/PopoverClickOutside';
import ChangeLogScroll from '@/core/directives/InfiniteScroll/ChangeLogScroll';
import AutoFocus from '@/core/directives/AutoFocus';
import '@/core/styles/global-modules.scss';

import SmartTable from 'vuejs-smart-table';

// import { disableMouseWheelOnNumberInputs } from '@/core/domHelpers';

// // Call the function to disable mouse wheel input changes on number inputs
// disableMouseWheelOnNumberInputs();

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(VueTour);

Drilldown(Highcharts);
PieTitlePlugin(Highcharts);
ZeroAlignPlugin(Highcharts);
ColumnSelectionShowRangePlugin(Highcharts);
Vue.use(HighchartsVue);

Vue.component('GenericProps', GenericProps);

Vue.component('VueSlider', VueSlider);

Vue.component('Btn', Btn);
Vue.component('BtnGroup', BtnGroup);
Vue.component('BtnToolbar', BtnToolbar);
Vue.component('Dropdown', Dropdown);
Vue.component('Modal', Modal);
Vue.component('Popover', Popover);
Vue.component('Tabs', Tabs);
Vue.component('Tab', Tab);
Vue.component('Collapse', Collapse);
Vue.component('Pagination', Pagination);
Vue.component('Typeahead', Typeahead);
Vue.component('ProgressBar', ProgressBar);
Vue.component('VSelect', vSelect);
Vue.component('FileUpload', VueUploadComponent);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('PrimaryButton', PrimaryButton);
Vue.component('MultipleToggle', MultipleToggle);
Vue.component('Field', Field);
Vue.component('PortalWidget', PortalWidget);
Vue.component('ColumnToggle', ColumnToggle);
Vue.component('Loader', Loader);
Vue.use(SmartTable);
Vue.directive('tooltip', tooltip);
Vue.directive('clipboard', copyToClipboard);
Vue.directive('focus', AutoFocus);
Vue.directive('prefix', PrefixInput);
Vue.directive('numbersOnly', NumbersOnly);
Vue.directive('clickOutside', PopoverClickOutside);
Vue.directive('changeLogInfiniteScroll', ChangeLogScroll);

// TODO: remove this from here and import it where it's used
Vue.filter('camelCaseFormat', camelCaseFormat);
Vue.filter('utcToLocalFormat', utcToLocalFormat);

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ServerSideRowModelModule,
  CsvExportModule,
  MasterDetailModule,
  RowGroupingModule,
  MenuModule,
  ColumnsToolPanelModule,
  SideBarModule,
  ExcelExportModule,
  RangeSelectionModule,
  ClipboardModule
]);

// Bootstrap angular Ringba Portal module Vue wrapper...
console.log(ringbaPortalComponents.name); // eslint-disable-line no-console
LicenseManager.setLicenseKey('Ringba_Ringba_single_1_Devs_1_Deployment_License_20_December_2020_[v2]_MTYwODQyMjQwMDAwMA==65aa7ae770cfb59a72668d48b35d7af1');

import './whitelabel.js';
